<template>
  <v-main v-if="isLoaded" class="d-flex align-center justify-center h-screen">
    <v-card v-if="reIssuance.oneTimeResultCode === 'VALID'" width="600">
      <v-card-title class="screen-title">パスワード再発行</v-card-title>
      <v-card-text>
        <validation-observer v-slot="{ handleSubmit }" as="div">
          <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
            <div class="pa-2">
              <validation-provider
                label="ログインID"
                name="loginId"
                :rules="{ required: true, login_id_with_v_number: true }"
                v-slot="{ componentField, errorMessage, meta }"
                v-model="form.loginId"
              >
                <v-row>
                  <v-col>
                    <app-badge
                      item="ログインID"
                      :msg="$filter.message(`info_LoginId_vnumber`)"
                    ></app-badge>
                    <small> ・申請中またはご利用中のログインID </small>
                    <app-form-input
                      type="text"
                      v-bind="componentField"
                      :error-messages="errorMessage"
                      :field-meta="meta"
                    />
                  </v-col>
                </v-row>
              </validation-provider>
            </div>
            <div class="pa-2">
              <validation-provider
                label="メールアドレス"
                name="email"
                :rules="{
                  required: true,
                  is_email: true,
                  max: { length: 127 },
                }"
                v-model="form.email"
                v-slot="{ componentField, errorMessage, meta }"
              >
                <v-row>
                  <v-col>
                    <app-badge
                      item="メールアドレス"
                      :msg="$filter.message('info_mail')"
                    ></app-badge>
                    <small
                      >・パスワードは下記メールアドレス宛に送付されます。<br />
                      ・メールアドレスは大文字、小文字が区別されますのでご注意ください。</small
                    >
                    <app-form-input
                      type="text"
                      v-bind="componentField"
                      :error-messages="errorMessage"
                      :field-meta="meta"
                    />
                  </v-col>
                </v-row>
              </validation-provider>
            </div>
            <v-card-actions>
              <v-list-item class="w-100 pa-1">
                <template v-slot:append>
                  <v-btn color="primary" variant="flat" type="submit"
                    >パスワード発行
                  </v-btn>
                </template>
              </v-list-item>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-card-text>
    </v-card>
    <v-card v-else width="800" class="pa-4">
      <v-card-title class="screen-title">無効なURLへアクセス</v-card-title>
      <v-card-text class="pt-4">
        <p>
          無効なURLへアクセスしております。URLを確認して再度アクセスするか、<br />
          もしくは「
          <router-link class="item-link" to="/password/one-time-url">
            パスワードの再発行はこちらへ
          </router-link>
          」から再発行手続きを行ってください。
        </p>
        <v-table class="mt-5 mb-2 table-bordered">
          <tbody>
            <tr>
              <th bgcolor="paleturquoise" class="font-weight-bold">
                お問い合わせ先
              </th>
              <td>{{ reIssuance.contact }}</td>
            </tr>
            <tr>
              <th bgcolor="paleturquoise" class="font-weight-bold">電話番号</th>
              <td>{{ reIssuance.contactPhone }}</td>
            </tr>
            <tr>
              <th bgcolor="paleturquoise" class="font-weight-bold">受付時間</th>
              <td>{{ reIssuance.acceptanceDateTime }}</td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
    </v-card>
  </v-main>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type { PostReIssuance, ReIssuance } from "@/apis/PasswordApi";

export default defineComponent({
  name: "PasswordReset",
  props: {
    /** ワンタイム認証キー */
    identifykey: {
      type: String as PropType<string>,
      default: null,
    },
  },
  data() {
    return {
      form: {
        loginId: "",
        email: "",
        loginUrl: `${window.location.origin}/login`,
      } as PostReIssuance,
      reIssuance: {} as ReIssuance,
      isLoaded: false,
    };
  },
  async mounted() {
    this.reIssuance = await this.$api.password.getReIssuance(this.identifykey);
    this.isLoaded = true;
  },
  methods: {
    async submit() {
      await this.$api.password.postReIssuance(this.identifykey, this.form);
      await this.$router.push("/password/reset/complete");
    },
  },
});
</script>
